const _jsxFileName = "/codebuild/output/src3182596400/src/codeconnections.ap-southeast-1.amazonaws.com/git-http/178309656639/ap-southeast-1/c294c899-f583-4463-ab85-039718732de9/suphachai2/mobileschool/ms-shared/src/components/auth/session_expiry_provider.jsx";import React, { useEffect, useRef, useState, useSyncExternalStore } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { useTranslation } from 'react-i18next';
import './style/session_expiry_dialog.css';
import {
    clearExpiredSession,
    getSessionExpired,
    getSessionLoginUrl,
    isSessionCallback,
    isSessionExpired,
    subscribeSessionExpiry,
    watchSessionExpiry,
} from '../../services/session_expiry';

const DEFAULT_TOKEN_KEYS = ['token'];
const DEFAULT_LOGIN_PATHS = ['/', '/login'];

export default function SessionExpiryProvider({ children, tokenKeys = DEFAULT_TOKEN_KEYS, loginUrl, loginPaths = DEFAULT_LOGIN_PATHS }) {
    const { t } = useTranslation();
    const notified = useSyncExternalStore(subscribeSessionExpiry, getSessionExpired, () => false);
    const [ready, setReady] = useState(false);
    const redirecting = useRef(false);
    const isLoginPage = loginPaths.includes(window.location.pathname.replace(/\/$/, '') || '/');
    const callback = isSessionCallback();
    const needsLoginCleanup = !callback && isLoginPage && (notified || isSessionExpired(tokenKeys));
    const visible = ready && !callback && !isLoginPage && notified;

    useEffect(() => {
        if (ready || redirecting.current) return;
        // A session that expired before opening the app is an ordinary login.
        // Keep pages unmounted until stale credentials have been removed.
        if (!callback && isSessionExpired(tokenKeys)) {
            clearExpiredSession();
            if (!isLoginPage) {
                redirecting.current = true;
                window.location.replace(loginUrl || getSessionLoginUrl());
                return;
            }
        }
        setReady(true);
    }, [ready, callback, isLoginPage, loginUrl, tokenKeys]);

    useEffect(() => {
        if (needsLoginCleanup) clearExpiredSession();
    }, [needsLoginCleanup]);

    useEffect(() => {
        if (ready) return watchSessionExpiry(tokenKeys);
    }, [ready, tokenKeys, notified]);

    const confirm = () => {
        redirecting.current = true;
        setReady(false);
        clearExpiredSession();
        window.location.replace(loginUrl || getSessionLoginUrl());
    };

    return (
        React.createElement(React.Fragment, null
            , ready && !visible && !needsLoginCleanup && children
            , React.createElement(Dialog, {
                header: t('sessionExpiry.title'),
                visible: visible,
                modal: true,
                closable: false,
                closeOnEscape: false,
                dismissableMask: false,
                draggable: false,
                resizable: false,
                className: "session-expiry-dialog",
                onHide: () => {},
                footer: 
                    React.createElement('div', { className: "session-expiry-dialog__actions", __self: this, __source: {fileName: _jsxFileName, lineNumber: 74}}
                        , React.createElement(Button, { type: "button", label: t('sessionExpiry.confirm'), className: "session-expiry-dialog__confirm bg-green-btn" , onClick: confirm, autoFocus: true, __self: this, __source: {fileName: _jsxFileName, lineNumber: 75}} )
                    )
                , __self: this, __source: {fileName: _jsxFileName, lineNumber: 62}}

                , React.createElement('p', { className: "session-expiry-dialog__message", __self: this, __source: {fileName: _jsxFileName, lineNumber: 79}}, t('sessionExpiry.message'))
            )
        )
    );
}
